export const BACKUP_FORM_NAME = 'nimpeeBackupForm';

export const FTP_TYPE_OPTIONS = [
  { value: 'local', label: 'Local hard drive' },
  { value: 'ftp', label: 'FTP' },
  { value: 'sftp', label: 'SFTP' },
];
